export const GET_DASHBOARD_REQUESTED = 'GET_DASHBOARD_REQUESTED';
export const GET_DASHBOARD_COMPLETED = 'GET_DASHBOARD_COMPLETED';
export const GET_DASHBOARD_FAILED = 'GET_DASHBOARD_FAILED';

export const RESET_DASHBOARD_REQUESTED = 'RESET_DASHBOARD_REQUESTED';
export const RESET_DASHBOARD_COMPLETED = 'RESET_DASHBOARD_COMPLETED';

export const GET_DASHBOARD_ACTIONS_REQUESTED =
  'GET_DASHBOARD_ACTIONS_REQUESTED';
export const GET_DASHBOARD_ACTIONS_COMPLETED =
  'GET_DASHBOARD_ACTIONS_COMPLETED';
export const GET_DASHBOARD_ACTIONS_FAILED = 'GET_DASHBOARD_ACTIONS_FAILED';
